import actions from './actions';

const {
  getSymbolBegin,
  getSymbolSuccess,
  getSymbolErr,
  setSymbolBegin,
  setSymbolSuccess,
  setSymbolErr,
  setForecastHorizonBegin,
  setForecastHorizonSuccess,
  setForecastHorizonErr,
  getModelIdBegin,
  getModelIdSuccess,
  getModelIdErr,
  setModelIdBegin,
  setModelIdSuccess,
  setModelIdErr,
} = actions;

const getSymbolAction = () => {
  return async dispatch => {
    try {
      dispatch(getSymbolBegin());
      dispatch(getSymbolSuccess());
    } catch (err) {
      dispatch(getSymbolErr(err));
    }
  };
};

const setSymbolAction = selectedSymbol => {
  return async dispatch => {
    try {
      dispatch(setSymbolBegin());
      dispatch(setSymbolSuccess(selectedSymbol));
    } catch (err) {
      dispatch(setSymbolErr(err));
    }
  };
};

const setForecastHorizonAction = selectedForecastHorizon => {
  return async dispatch => {
    try {
      dispatch(setForecastHorizonBegin());
      dispatch(setForecastHorizonSuccess(selectedForecastHorizon));
    } catch (err) {
      dispatch(setForecastHorizonErr(err));
    }
  };
};

const getModelIdAction = () => {
  return async dispatch => {
    try {
      dispatch(getModelIdBegin());
      dispatch(getModelIdSuccess());
    } catch (err) {
      dispatch(getModelIdErr(err));
    }
  };
};

const setModelIdAction = selectedModelId => {
  return async dispatch => {
    try {
      dispatch(setModelIdBegin());
      dispatch(setModelIdSuccess(selectedModelId));
    } catch (err) {
      dispatch(setModelIdErr(err));
    }
  };
};

export { getSymbolAction, setSymbolAction, setForecastHorizonAction, getModelIdAction, setModelIdAction };
